module.exports = __webpack_public_path__ + "static/landing-pc/img/logo_top.79fdb8c2.png";